import { render } from "./EmergencyContactForm.vue?vue&type=template&id=69f0d485"
import script from "./EmergencyContactForm.vue?vue&type=script&lang=js"
export * from "./EmergencyContactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__